import { AbstractModel, DateUtil, UzurvDataSource, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class Journey extends AbstractModel {
  @autoserialize
  medusaJourneyIdentifier: number;

  @autoserialize
  operationalFootprintId: number;

  @autoserializeAs(Date)
  itineraryDate: Date;

  @autoserializeAs(Date)
  startDate: Date;

  @autoserializeAs(Date)
  endDate: Date;

  @autoserialize
  startDisplay: string;

  @autoserialize
  startLatitude: number;

  @autoserialize
  startLongitude: number;

  @autoserialize
  endDisplay: string;

  @autoserialize
  endLatitude: number;

  @autoserialize
  endLongitude: number;

  @autoserialize
  period2DistanceMiles: number;

  @autoserialize
  period3DistanceMiles: number;

  @autoserialize
  totalDistanceMiles: number;

  @autoserialize
  deadheadDurationSeconds: number;

  @autoserialize
  period2DurationSeconds: number;

  @autoserialize
  period3DurationSeconds: number;

  @autoserialize
  totalDurationSeconds: number;

  @autoserialize
  driverFareEstimate: number;

  @autoserialize
  paired: boolean;

  @autoserialize
  rideCount: number;

  @autoserialize
  active: boolean;

  @autoserialize
  driverId: number;

  @autoserialize
  timeZone: string;

  @autoserialize
  source: UzurvDataSource;

  get sourceJourneyIdentifier(): number {
    if (this.source === UzurvDataSource.Medusa) {
      return this.medusaJourneyIdentifier;
    }

    return this.id;
  }

  public static OnSeserialized(instance: Journey, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(json['itineraryDate'])) {
      json['itineraryDate'] = DateUtil.serializeLocalDate(instance.itineraryDate);
    }

    if (!isNullOrUndefined(json['startDate'])) {
      json['startDate'] = DateUtil.serializeInstant(instance.startDate);
    }

    if (!isNullOrUndefined(json['endDate'])) {
      json['endDate'] = DateUtil.serializeInstant(instance.endDate);
    }
  }

  public static OnDeserialized(instance: Journey, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['itineraryDate'])) {
      instance.itineraryDate = DateUtil.deserializeLocalDate(json['itineraryDate']);
    }

    if (!isNullOrUndefined(json['startDate'])) {
      instance.startDate = DateUtil.deserializeInstant(json['startDate']);
    }

    if (!isNullOrUndefined(json['endDate'])) {
      instance.endDate = DateUtil.deserializeInstant(json['endDate']);
    }
  }
}
